import 'styles/app/components/_six_payment_form.scss'
